/* Galerie de fiche produit — photo agrandie au clic et au tap.
   Lot 154 (D20 point 4). Fichier séparé de `product-configurator.js` :
   l'agrandissement ne dépend d'aucune variante ni d'aucun axe d'option,
   seulement de `[data-gallery]` et du `<dialog data-gallery-zoom>` rendu par
   la section — chargé sur `product` avec la même garde que le configurateur
   (`layout/theme.liquid`).

   Réglage d'extinction : `gallery_zoom` (schéma de `sections/main-product.
   liquid`). Décoché, la section ne rend ni le `<dialog>` ni `data-zoom-src`
   sur les médias : ce script ne trouve rien et ne pose aucun écouteur — la
   galerie reste exactement celle d'avant.

   Un média vidéo ou vidéo externe n'a jamais `data-zoom-src` (posé en Liquid
   seulement pour `media_type == 'image'`) : un tap dessus n'ouvre rien.

   Lot 160 — la photo agrandie s'ouvre en plein écran sur fond clair (CSS) et
   se parcourt de trois façons : les flèches, les touches ← et →, et le
   glissement du doigt. On ferme par la croix, par Échap ou en touchant à
   côté de l'image. Le verrou de défilement de la page est en CSS pur
   (`assets/sbc-base.css`, règle `:has()` partagée avec le lecteur vidéo) :
   aucune classe posée ici, donc aucun verrou qui puisse rester coincé si une
   sortie était manquée. */
(() => {
  const SEUIL_GLISSEMENT = 6; /* px — même seuil que le glissement du lot 155 */

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const scope = gallery.closest('.shopify-section') || document;
    const dialog = scope.querySelector('[data-gallery-zoom]');
    const track = gallery.querySelector('[data-gallery-track]');
    if (!dialog || typeof dialog.showModal !== 'function' || !track) return;

    const img = dialog.querySelector('[data-zoom-img]');
    const closeBtn = dialog.querySelector('[data-zoom-close]');
    const prevBtn = dialog.querySelector('[data-zoom-prev]');
    const nextBtn = dialog.querySelector('[data-zoom-next]');
    if (!img) return;

    /* Liste fixe : tous les médias du produit sont rendus au chargement, le
       JS ne fait ensuite que basculer `is-active` — rien n'est ajouté ni
       retiré du DOM, la liste n'a donc besoin d'être lue qu'une fois.

       Clôture de vague 151-159 — chaque média reçoit un vrai `<button>`
       plein cadre (amélioration progressive, le balisage Liquid des médias
       ne change pas) : le déclencheur au clavier n'est plus le `<div>`
       `.product-media` (tabIndex=-1, invisible au Tab) mais ce bouton, qui
       porte l'étiquette lue sur `[data-gallery]` (`data-zoom-label`, posée
       en Liquid — le texte n'est jamais écrit ici) et sa position dans la
       série. */
    const images = Array.from(gallery.querySelectorAll('.product-media[data-zoom-src]'));
    const zoomLabel = gallery.dataset.zoomLabel || 'Agrandir la photo';
    images.forEach((media, index) => {
      const bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'product-media__zoom';
      bouton.setAttribute('aria-label', `${zoomLabel} ${index + 1} sur ${images.length}`);
      media.appendChild(bouton);
    });
    if (!images.length) return;

    let declencheur = null;
    let indexCourant = -1;

    const afficher = (index) => {
      const media = images[index];
      if (!media) return;
      indexCourant = index;
      img.src = media.dataset.zoomSrc;
      img.alt = media.querySelector('img')?.alt || '';
      const plusieurs = images.length > 1;
      if (prevBtn) prevBtn.hidden = !plusieurs;
      if (nextBtn) nextBtn.hidden = !plusieurs;
      /* Lot 160 — les deux voisines se préchargent : le changement de photo
         au glissement doit être instantané, pas un cadre vide le temps du
         téléchargement. Rien n'est préchargé tant que personne n'ouvre. */
      if (plusieurs) {
        [(index + 1) % images.length, (index - 1 + images.length) % images.length].forEach((i) => {
          const src = images[i]?.dataset.zoomSrc;
          if (src) new Image().src = src;
        });
      }
    };

    const suivante = (pas) => afficher((indexCourant + pas + images.length) % images.length);

    const ouvrirDepuis = (media) => {
      const index = images.indexOf(media);
      if (index === -1) return;
      /* Le focus doit revenir sur le bouton (visible, tabulable), jamais sur
         le `<div>` qui le contient : à défaut de bouton trouvé (garde), le
         média lui-même reste un repli inoffensif. */
      declencheur = media.querySelector('.product-media__zoom') || media;
      afficher(index);
      if (!dialog.open) dialog.showModal();
      /* `showModal()` donne déjà le focus au premier élément focusable — la
         croix. On le pose explicitement : l'ordre du DOM ne doit pas être la
         seule garantie de ce comportement. */
      closeBtn?.focus();
    };

    const fermer = () => { if (dialog.open) dialog.close(); };

    /* L'évènement natif `close` couvre les trois sorties (bouton, Échap,
       fond) : un seul endroit pour vider l'image et rendre le focus. */
    dialog.addEventListener('close', () => {
      img.removeAttribute('src');
      /* `preventScroll` depuis le lot 160 : la page est figée pendant
         l'ouverture (verrou CSS partagé), le déclencheur est donc resté
         exactement là où la cliente l'a laissé — le navigateur n'a plus
         aucune raison de faire défiler pour le ramener. Sans cette option,
         la fermeture déplaçait la page de 25 px (mesuré à 1280). */
      declencheur?.focus({ preventScroll: true });
    });
    closeBtn?.addEventListener('click', fermer);
    /* Cible = le dialogue lui-même (pas un enfant) : c'est le fond, jamais
       l'image ni un bouton, qui couvrent tout le reste de sa boîte. */
    dialog.addEventListener('click', (event) => { if (event.target === dialog) fermer(); });
    /* Écouteur explicite plutôt que la seule fermeture native du `<dialog>` :
       un Échap synthétique (contrôle DOM, lecteur d'écran logiciel) ne
       déclenche pas toujours le comportement par défaut du navigateur. */
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); fermer(); }
      else if (event.key === 'ArrowLeft' && images.length > 1) { event.preventDefault(); suivante(-1); }
      else if (event.key === 'ArrowRight' && images.length > 1) { event.preventDefault(); suivante(1); }
    });
    prevBtn?.addEventListener('click', () => suivante(-1));
    nextBtn?.addEventListener('click', () => suivante(1));

    /* Lot 160 — changer de photo au doigt, dans le dialogue.

       En évènements TACTILES, jamais en `pointer*` : un défilement natif
       annule les pointeurs (`pointercancel`) mais pas les touchers, et le
       pincement-zoom du navigateur doit rester possible — donc aucun
       `touch-action` restrictif ni `preventDefault()` ici.

       Conditions d'un vrai glissement : un seul doigt du début à la fin,
       48 px au moins, franchement horizontal (1,5 ×), et la vue non zoomée
       aux deux bouts — si la cliente a pincé pour agrandir, son doigt
       DÉPLACE la vue, il ne change pas de photo. */
    const SEUIL_PHOTO = 48;
    const echelle = () => (window.visualViewport ? window.visualViewport.scale : 1);
    let toucher = null;
    dialog.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1 || echelle() > 1.01) { toucher = null; return; }
      const t = event.touches[0];
      toucher = { x: t.clientX, y: t.clientY };
    }, { passive: true });
    dialog.addEventListener('touchend', (event) => {
      const depart = toucher;
      toucher = null;
      if (!depart || images.length < 2) return;
      if (event.touches.length !== 0 || event.changedTouches.length !== 1) return;
      if (echelle() > 1.01) return;
      const t = event.changedTouches[0];
      const dx = t.clientX - depart.x;
      const dy = t.clientY - depart.y;
      if (Math.abs(dx) < SEUIL_PHOTO || Math.abs(dx) <= Math.abs(dy) * 1.5) return;
      suivante(dx < 0 ? 1 : -1);
    }, { passive: true });
    dialog.addEventListener('touchcancel', () => { toucher = null; }, { passive: true });

    /* Un glissement sur la piste mobile (`scroll-snap`) ne doit jamais ouvrir
       le dialogue : seuil de 6px entre pointerdown et pointerup, même seuil
       que le lot 155. Rien n'appelle `preventDefault()` ici : le défilement
       et le compteur de médias continuent de fonctionner normalement. */
    let depart = null;
    let glisse = false;
    track.addEventListener('pointerdown', (event) => {
      depart = { x: event.clientX, y: event.clientY };
      glisse = false;
    });
    track.addEventListener('pointermove', (event) => {
      if (!depart) return;
      if (Math.hypot(event.clientX - depart.x, event.clientY - depart.y) > SEUIL_GLISSEMENT) glisse = true;
    });
    track.addEventListener('pointerup', () => { depart = null; });
    track.addEventListener('click', (event) => {
      if (glisse) { glisse = false; return; }
      const media = event.target.closest('.product-media[data-zoom-src]');
      if (!media) return;
      ouvrirDepuis(media);
    });
  });
})();
